import React from 'react';
export const Mecanismo: React.FC = () => {
  const cards = [{
    emoji: '🎨',
    text: 'Más creatividad'
  }, {
    emoji: '🧠',
    text: 'Más concentración'
  }, {
    emoji: '✨',
    text: 'Más imaginación'
  }, {
    emoji: '📵',
    text: 'Menos tiempo frente al celular'
  }, {
    emoji: '👨‍👩‍👧‍👦',
    text: 'Más momentos en familia'
  }];
  return <section className="py-9 px-4 bg-cream-dark/40" data-id="element-108">
      <div className="max-w-2xl mx-auto" data-id="element-109">
        <h2 className="font-rounded font-bold text-[1.75rem] sm:text-[2.25rem] text-violet text-center leading-[1.1] mb-2" data-id="element-110">
          La mayoría de los padres intenta{' '}
          <span className="line-through opacity-60" data-id="element-111">quitar</span> las pantallas.
          Nosotros preferimos{' '}
          <span className="text-gold-dark" data-id="element-112">reemplazarlas</span>.
        </h2>

        <div className="text-center mb-5 mt-4" data-id="element-113">
          <div className="inline-block bg-violet text-yellow font-rounded font-bold uppercase tracking-widest text-[11px] px-3.5 py-1.5 rounded-full mb-3" data-id="element-114">
            ✨ Método Disney Sin Pantallas™
          </div>
          <p className="text-textsoft font-semibold text-base leading-snug max-w-md mx-auto" data-id="element-115">
            Un sistema simple que combina personajes que los chicos ya aman con
            actividades creativas que los mantienen entretenidos durante horas.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2.5 mb-6" data-id="element-116">
          {cards.map((c, idx) => <div key={idx} className={`bg-white rounded-2xl p-3.5 flex flex-col items-center text-center gap-1.5 shadow-card border border-gold/20 ${cards.length % 2 !== 0 && idx === cards.length - 1 ? 'col-span-2 sm:col-span-1' : ''}`} data-id="element-117">
              <span className="text-3xl leading-none" data-id="element-118">{c.emoji}</span>
              <span className="text-violet font-rounded font-bold text-xs sm:text-sm leading-tight" data-id="element-119">
                {c.text}
              </span>
            </div>)}
        </div>

        <div className="bg-violet text-cream rounded-2xl p-5 sm:p-6 text-center shadow-xl border-2 border-gold/40" data-id="element-120">
          <p className="font-rounded font-bold text-base sm:text-lg leading-snug" data-id="element-121">
            No se trata de prohibir las pantallas.
          </p>
          <p className="font-rounded font-bold text-lg sm:text-xl text-yellow leading-snug mt-1" data-id="element-122">
            Se trata de ofrecer algo tan entretenido que quieran elegir otra
            cosa.
          </p>
        </div>
      </div>
    </section>;
};